import intl from "react-intl-universal";
import { DescriptionText, SectionContent } from "../../styled";

interface SupplierSelectionProps {
  mainSupplier?: string;
  criteria?: string;
  description?: string;
}

const SupplierSelection = (props: SupplierSelectionProps) => {
  const { mainSupplier, criteria, description } = props;

  return (
    <SectionContent>
      <DescriptionText $fontWeight={700} $fontSize="0.75rem">
        {intl.get("stocks.suggestionContext.supplierSelection.title")}
      </DescriptionText>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.supplierSelection.supplierLabel")}
        </DescriptionText>
        <DescriptionText>{`${mainSupplier}`}</DescriptionText>
      </div>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.supplierSelection.criteriaLabel")}
        </DescriptionText>
        <DescriptionText>{`${criteria}`}</DescriptionText>
      </div>

      <DescriptionText>{`${description}`}</DescriptionText>
    </SectionContent>
  );
};

export default SupplierSelection;
